import React, { useState, useEffect } from "react";
import { useStep } from "../../contexts/stepContexts";
import { getTimeRemaining } from "../../utils/countdownUtils";

const EidSalePricing = () => {
  const { showEidMarketing } = useStep();
  const [daysLeft, setDaysLeft] = useState(getTimeRemaining().days);

  useEffect(() => {
    const calculateDaysLeft = () => {
      setDaysLeft(getTimeRemaining().days);
    };

    calculateDaysLeft();
    const interval = setInterval(calculateDaysLeft, 1000 * 60 * 60); // Update every hour

    return () => clearInterval(interval);
  }, []);

  if (!showEidMarketing) return null;

  return (
    <div className="w-full max-w-5xl mx-auto mb-12 mt-5">
      <div className="bg-gradient-to-r from-green-500/10 to-green-500/5 border border-green-500/20 rounded-lg p-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <div className="inline-block bg-green-500/20 px-4 py-1 rounded-full mb-4">
              <span className="text-green-400 font-medium">🎉 Eid Mubarak Special Offer!</span>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">Get 25% Off on All Packages</h3>
            <p className="text-gray-300">
              Limited time offer - Use code{" "}
              <span className="bg-green-500/20 text-green-400 font-mono px-3 py-1 rounded">EID25</span>
            </p>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400">25%</div>
              <div className="text-sm text-gray-400">Discount</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-400">{daysLeft}</div>
              <div className="text-sm text-gray-400">Days Left</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EidSalePricing; 